export default "__VITE_ASSET__CE96oJ3V__"